import { postData } from '@/utils/api';
import { ApiResponse, RequestOptions } from '@/types/api';
import { NotificationsApiModel, NotificationIdLabelDataModel } from '@/types/notifications';

/**
 * 通知一覧取得
 */
export async function getNotifications(
  formData: NotificationIdLabelDataModel,
  csrftoken: string,
  options?: RequestOptions
): Promise<ApiResponse<NotificationsApiModel>> {
  const apiPath = `notifications/`;

  return await postData<NotificationsApiModel>(apiPath, csrftoken, formData, options);
}
